import * as React from "react";
import { SVGProps } from "react";

const CoinmetroToken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 220 220"
    {...props}
  >
    <style>{".st1{fill:#40d8c8}"}</style>
    <path
      fill="#131218"
      d="M110 220c60.8 0 110-49.2 110-110S170.8 0 110 0 0 49.2 0 110s49.2 110 110 110z"
    />
    <path
      d="M106.1 96.7 70.1 61c-1-1-2.8-1.1-3.9-.1-.9.8-1.9 1.8-2.7 2.7-1 1.1-1 2.9.1 3.9l36.1 35.8c3.7 3.6 3.7 9.6 0 13.2l-43 42.7c-.9.9-2.4.8-3.3-.2l-.1-.1c-2.5-3-2.3-7.4.5-10.1l37.3-37c1.1-1.1 1.1-2.9 0-3.9L54.8 72.2c-3.5-3.5-3.8-9-.5-12.7 2.3-2.7 5-5.2 7.6-7.6 3.8-3.3 9.3-3 12.8.5l36.1 35.8c1.1 1.1 2.9 1.1 3.9 0l37-37c2.7-2.7 7-3 10-.6l.1.1c1.2 1 1.1 2.5.6 3.2l-43.2 42.9c-3.5 3.6-9.4 3.6-13.1-.1z"
      className="st1"
    />
    <path
      d="m42.3 78.1-.8 2c-.8 2.1-.4 4.5 1.2 6.2l23.2 23c.4.4.4.9 0 1.3l-23.2 23c-1.6 1.6-2.1 4.1-1.2 6.2.3.7.6 1.3.9 2 .8 1.8 3.2 2.1 4.5.8l30.8-30.7c1.1-1.1 1.1-2.9 0-3.9L46.9 77.2c-1.5-1.3-3.8-.9-4.6.9zM171.8 71c2.7-2.8 2.9-7.1.4-10.2-.8-1-2.4-1.1-3.3 0l-42.8 42.7c-3.7 3.6-3.7 9.5 0 13.2l35.9 35.7c1.1 1.1 1.1 2.8.1 3.9l-2.8 2.8c-1.1 1-2.9 1-3.9-.1l-35.8-35.8c-3.7-3.6-9.7-3.6-13.3 0l-43 42.7c-.9.9-.8 2.4.2 3.3l.1.1c2.9 2.4 7.3 2.2 10-.5l37.4-37.1c1-1.1 2.8-1.1 3.9 0l35.9 35.8c3.4 3.4 9.2 3.6 12.8.6 2.6-2.2 5.2-4.8 7.5-7.5 3.3-3.7 3.1-9.3-.4-12.8l-35.9-35.9c-1.1-1-1.1-2.8 0-3.9l37-37z"
      className="st1"
    />
  </svg>
);

export default CoinmetroToken;
